export default {
  inserted: (formElement) => {
    function scroll(event) {
      const errorElement = formElement.querySelector('.ant-form-item-control.has-error');
      if (errorElement) {
        errorElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      event.preventDefault();
    }
    formElement.addEventListener('submit', scroll);
  }
};
